export const vsName = 'selectedMachinesService'
export const vsNgType = 'factory'

selectedMachinesService.$inject = ['collection']
export function selectedMachinesService(collection) {
  return new collection('Id', 'machineAdded', 'machineRemoved', 'selectedMachinesChanged')
}
